<template>
  <f7-page name="terms" no-toolbar no-swipeback-tmp>
    <div v-if="termList.length > 0" class="terms">
      <CommonHeader
        :background="'#FFFFFF'"
        :color="'#242323'"
        :text="'other_termsNavTitle'"
        :question-icon-url="'static/images/common/icon_question.svg'"
        :close-icon-url="'static/images/common/icon_close.svg'"
        :show-back="isInIndex"
        :show-close="isInIndex"
        :show-f-a-q="isInIndex"
        :show-border="true"
      />
      <div class="index block">
        <p>{{ t('other_termsContent') }}</p>
        <ul>
          <li v-for="(item, i) in termList" :key="i">
            <a
              :key="i"
              :href="'#'"
              class="scrollpage link"
              @click.prevent="scrollToSection(i)"
            >
              {{ item.title }}
            </a>
          </li>
        </ul>
      </div>
      <div
        v-for="(item, i) in termList"
        :id="i.toString()"
        :key="i"
        :ref="
          (el) => {
            if (el) sectionRefs[i] = el
          }
        "
        class="block items"
      >
        <p class="title">{{ item.title }}</p>
        <p class="text" v-html="item.term"></p>
      </div>
    </div>
  </f7-page>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n-bridge'
import CommonHeader from '@/components/CommonHeader.vue'
import { getConfigBaseUrl } from '@/utils/env'

const { t } = useI18n()

const isInIndex = !new URL(window.location.href).searchParams.get('to')

type TermItem = {
  title: string
  term: string
}
const termList = ref<TermItem[]>([])

const sectionRefs = ref<{ [key: string]: HTMLElement }>({})
const scrollToSection = (id: string) => {
  const element = sectionRefs.value[id]
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

onMounted(async () => {
  g.showLoading()
  const response = await fetch(`${getConfigBaseUrl()}point-terms-and-conditions.json`, {
    cache: 'no-cache',
  })
  const jsonData = await response.json()
  termList.value = jsonData?.content as TermItem[] || []
  g.hideLoading()

  if (window.location.hash) {
    const id = window.location.hash.substring(1)
    scrollToSection(id)
  }
  window.addEventListener('hashchange', () => {
    const id = window.location.hash.substring(1)
    scrollToSection(id)
  })
})
</script>
<style lang="scss" scoped>
.terms {
  background: #fff;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 30px;
}

.block {
  background: transparent;
  margin: 0px;
  padding: 0px 0px;
}

.page-content {
  padding-bottom: 100px;

  .block,
  .block p {
    margin: 0px;
    padding: 0px;
  }

  .block {
    &.index {
      padding: 20px 20px;
      z-index: 2;

      p {
        color: #242323;
        font-size: 18px;
        font-weight: bold;
        line-height: 24px;
        padding-bottom: 12px;
      }

      ul {
        list-style-type: none;
        padding-left: 20px;
        margin-block-start: 0px;
        margin-block-end: 0px;

        li {
          a {
            color: #00b9f5;
            font-size: 12px;
            font-weight: 400;
            line-height: 24px;
          }
        }
      }
    }

    &.items {
      padding: 80px 20px 0px 20px;
      margin-top: -40px;

      .title {
        padding-bottom: 20px;
        color: #242323;
        font-size: 14px;
        font-weight: bold;
        line-height: 19px;
      }

      .text {
        color: #242323;
        font-size: 12px;
        font-weight: 400;
        line-height: 24px;
        word-break: break-all;

        .big {
          color: #242323;
          font-size: 14px;
          font-weight: bold;
          line-height: 19px;
        }
      }
    }
  }
}
</style>
